import { InitialPanelMemberListView } from "./components/InitialPanelMemberListView";
import { FinalPanelMemberListView } from "./components/FinalPanelMemberListView";
import type { PanelMemberListMode, FinalPanelMemberData } from "./components/types";

export type { FinalPanelMemberData } from "./components/types";

interface PanelMemberListProps {
	evalId: number;
	finalMembers?: FinalPanelMemberData[];
	mode?: PanelMemberListMode;
	rfxId: number;
}

/**
 * Renders the panel-member table for either the initial-scoring or
 * final-scoring view. Row/status/action presentation lives in ./components
 * and the shared components/PanelMembers/ module.
 */
export const PanelMemberList: React.FC<PanelMemberListProps> = ({
	rfxId,
	evalId,
	mode = "initial",
	finalMembers,
}) => {
	if (mode === "final" && finalMembers) {
		return <FinalPanelMemberListView finalMembers={finalMembers} />;
	}

	return <InitialPanelMemberListView rfxId={rfxId} evalId={evalId} mode={mode} />;
};
